import { gql } from '@apollo/client'

export const CHANGE_PASS_MUTATION = gql`
	mutation changePassword($oldPassword: String!, $password: String!, $passwordConfirmation: String!) {
		changePassword(oldPassword: $oldPassword, password: $password, passwordConfirmation: $passwordConfirmation) {
			success
			authToken {
				accessToken
				expiresIn
				refreshToken
				tokenType
			}
		}
	}
`

export const SIGN_OUT_WORKER_MUTATION = gql`
	mutation signOutWorker {
		workerSignOut {
			success
		}
	}
`

export const UPDATE_USER_QUIZZES_MUTATION = gql`
	mutation updateUserQuiz($quizId: String!, $state: ChangableUserQuizStateEnum, $userQuizAnswers: [UserQuizAnswerInput!]!) {
		updateUserQuiz(quizId: $quizId, state: $state, userQuizAnswers: $userQuizAnswers) {
			status
			user {
				__typename
			}
			userId
			userQuizzes {
				id
				previousStep
				quiz {
					id
					description
					name
					questionsCount
					quizQuestions {
						id
						name
						question
						questionOptions
						questionType
						requiredNoteIf
						description
					}
					resource {
						__typename
					}
				}
				state
				userQuizAnswers {
					answer
					id
					quizQuestionId
					correct
					files {
						file {
							fileUrl
							filename
							byteSize
							blobId
						}
						id
					}
					note
				}
			}
		}
	}
`

export const UPDATE_USER_QUIZ_MUTATION = gql`
	mutation autoSave($quizId: String!, $state: ChangableUserQuizStateEnum, $userQuizAnswers: [UserQuizAnswerInput!]!) {
		updateUserQuiz(quizId: $quizId, state: $state, userQuizAnswers: $userQuizAnswers) {
			status
			user {
				__typename
			}
			userId
			userQuizzes {
				id
				previousStep
				quiz {
					id
					description
					name
					questionsCount
					quizQuestions {
						id
						name
						question
						questionOptions
						questionType
						requiredNoteIf
						description
					}
					resource {
						__typename
					}
				}
				state
				userQuizAnswers {
					answer
					id
					quizQuestionId
					correct
					files {
						file {
							fileUrl
							filename
							byteSize
							blobId
						}
						id
					}
					note
				}
			}
		}
	}
`
